import { render, staticRenderFns } from "./Danger.vue?vue&type=template&id=ec6f0254&scoped=true&"
import script from "./Danger.vue?vue&type=script&lang=js&"
export * from "./Danger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec6f0254",
  null
  
)

export default component.exports